import { createRouter, createWebHistory } from 'vue-router'
import { api } from '@/api/client'
import { tryTelegramWebAppAuth } from '@/telegram/auth'
import Dashboard from '@/views/Dashboard.vue'
import ActivateCode from '@/views/ActivateCode.vue'
import SupportView from '@/views/SupportView.vue'
import ComplaintView from '@/views/ComplaintView.vue'
import AppsView from '@/views/AppsView.vue'
import NewsView from '@/views/NewsView.vue'
import SettingsView from '@/views/SettingsView.vue'
import PurchaseProductView from '@/views/PurchaseProductView.vue'

import LoginView from '@/views/LoginView.vue'

export const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    { path: '/login', name: 'login', component: LoginView, meta: { title: 'Вход', guest: true } },
    { path: '/', name: 'dashboard', component: Dashboard, meta: { title: 'Ключи' } },
    { path: '/activate', name: 'activate', component: ActivateCode, meta: { title: 'Активировать' } },
    { path: '/support', name: 'support', component: SupportView, meta: { title: 'Поддержка' } },
    { path: '/complaint', name: 'complaint', component: ComplaintView, meta: { title: 'Жалоба' } },
    { path: '/apps', name: 'apps', component: AppsView, meta: { title: 'Приложения' } },
    { path: '/news', name: 'news', component: NewsView, meta: { title: 'Новости' } },
    { path: '/settings', name: 'settings', component: SettingsView, meta: { title: 'Настройки' } },
    { path: '/buy/:productId', name: 'buy-product', component: PurchaseProductView, meta: { title: 'Покупка' } },
  ],
})

let authChecked = false

export function markAuthChecked(): void {
  authChecked = true
}

export function resetAuthChecked(): void {
  authChecked = false
}

router.beforeEach(async (to) => {
  if (to.meta.guest) return true
  if (!authChecked) {
    await tryTelegramWebAppAuth()
  }
  if (authChecked) return true
  try {
    await api.get('/api/user/profile')
    authChecked = true
    return true
  } catch {
    const redirect = encodeURIComponent(to.fullPath === '/' ? '/' : to.fullPath)
    return { name: 'login', query: { redirect } }
  }
})
